import { useQuery } from '@tanstack/react-query';
import { queryContext } from "../context/fractal-sdk-context.js";
import { sdkApiClient } from "../core/api/client.js";
import { ApiFeature } from "../core/api/types.js";
import { FractalSDKGetCoinsUnknownError } from "../core/error/index.js";
import { useUser } from "../hooks/public/use-user.js";
import { isNotNullOrUndefined } from "../lib/guards/index.js";
var CoinApiKey;
(function (CoinApiKey) {
    CoinApiKey["GET_COINS"] = "GET_COINS";
})(CoinApiKey || (CoinApiKey = {}));
export const CoinApiKeys = {
    getCoins: (userId) => [ApiFeature.COINS, CoinApiKey.GET_COINS, userId],
};
export const useGetCoinsQuery = () => {
    const { data: user } = useUser();
    const query = useQuery(CoinApiKeys.getCoins(user === null || user === void 0 ? void 0 : user.userId), async () => CoinApi.getCoins(), {
        context: queryContext,
        enabled: isNotNullOrUndefined(user),
    });
    if (user === undefined) {
        query.remove();
    }
    return query;
};
const CoinApi = {
    getCoins,
};
async function getCoins() {
    const response = await sdkApiClient.v1.getCoins();
    if (response.error) {
        throw new FractalSDKGetCoinsUnknownError(`There was an error fetching coins. err = ${response.error.message}`);
    }
    return response.data;
}
//# sourceMappingURL=coins.js.map